import type { SessionUser } from "~~/server/middleware/auth";

/**
 * Tells the page-load script inlined in the HTML shell (scripts/perf-boot.js)
 * what only the app knows: when the app started, who is signed in, and whether
 * it showed an error page instead of the viewer (a missing or private case,
 * which isn't slow loading). Does nothing when that script isn't there.
 */
export default defineNuxtPlugin(() => {
  const boot = window.__pacsbinBoot;
  if (!boot) return;
  boot.appStartMs = performance.now();

  const session = useState<SessionUser | null>("session");
  watch(
    session,
    (s) => {
      boot.userId = s?._id ?? "";
    },
    { immediate: true }
  );

  const error = useError();
  watch(
    error,
    (e) => {
      if (e) boot.failed = true;
    },
    { immediate: true }
  );
});
